import { Form } from "react-final-form";
import { useIntl } from "react-intl";
import InputField from "@ticketingplatform/ui/dist/components/atoms/Fields/Input/InputField";
import CheckboxField from "@ticketingplatform/ui/dist/components/atoms/Fields/Checkbox/CheckboxField";

import * as Styled from "./styles";
import { BillingFormProps } from "./types";

const BillingForm: React.FC<BillingFormProps> = ({ children, ...props }) => {
  const intl = useIntl();

  return (
    <Form {...props}>
      {({ handleSubmit, submitError, values: { sendReceipt } }) => (
        <Styled.Form onSubmit={handleSubmit}>
          <InputField
            name="firstName"
            variant="tertiary"
            placeholder={intl.formatMessage({
              defaultMessage: "First Name*",
            })}
          />
          <InputField
            name="lastName"
            variant="tertiary"
            placeholder={intl.formatMessage({
              defaultMessage: "Last Name*",
            })}
          />
          <InputField
            name="email"
            variant="tertiary"
            placeholder={
              sendReceipt
                ? intl.formatMessage({
                    defaultMessage: "Email*",
                  })
                : intl.formatMessage({
                    defaultMessage: "Email (optional)",
                  })
            }
          />
          <InputField
            name="customerNotes"
            variant="tertiary"
            placeholder={intl.formatMessage({
              defaultMessage: "Note (optional)",
            })}
          />
          <CheckboxField
            name="sendReceipt"
            variant="secondary"
            label={intl.formatMessage({
              defaultMessage: "Send Receipt",
            })}
          />
          <CheckboxField
            name="autoCheckIn"
            variant="secondary"
            label={intl.formatMessage({
              defaultMessage: "Check-In",
            })}
          />
          {children}
          {submitError && <Styled.Error>{submitError}</Styled.Error>}
        </Styled.Form>
      )}
    </Form>
  );
};

export default BillingForm;
